import http from "./httpService";
import { apiUrl } from "../config.json";

// const apiEndpoint = apiUrl + "/record";
const apiEndpoint = apiUrl + "/rest_collection_clc_bookingconfirm";

export async function addRecord(data) {
  console.log("addRecord called: ", data);

  const result = await http.post(apiEndpoint, { ...data });
  console.log("addRecord Result: ", result);
}

export async function updateRecord(data) {
  console.log("updateRecord called: ", data);

  const result = await http.put(apiEndpoint, { ...data });
  console.log("updateRecord Result: ", result);
}

export async function deleteRecord(data) {
  console.log("deleteRecord called: ", data);

  const result = await http.delete(apiEndpoint, { data });
  console.log("updateRecord Result: ", result);
}

export async function readAllRecords() {
  console.log("readAllRecords called: ");

  const { data: results } = await http.get(apiEndpoint);
  const records = results.map(item => {
    let {
      id,
      startDate,
      endDate,
      members,
      title,
      userName,
      userMobile,
      userEmail,
      userOrganization,
      userTitle,
    } = item;
    return {
      id,
      startDate,
      endDate,
      members,
      title,
      userName,
      userMobile,
      userEmail,
      userOrganization,
      userTitle,
    };
  });
  return records;
}